import React from "react";
import "./_styles.scss";

export default function ProfilePage() {
  return (
    <div className="profile-page">
      Profile Section Coming Soon
      {/* <p>Located in "/src/_global/components/profile-page"</p> */}
    </div>
  );
}
